function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 10.7c-.9 0-1.6.7-1.6 1.6v16c0 1 .7 1.7 1.7 1.7h7.2a1.3 1.3 0 1 1 0 2.7H5.1c-2.4 0-4.4-2-4.4-4.4v-16C.7 10 2.7 8 5.1 8h24c2.3 0 4.3 2 4.3 4.3v5a1.3 1.3 0 1 1-2.7 0v-5c0-.9-.7-1.6-1.6-1.6H5Z",
  fill: "#333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.8 2.7c-1 0-2 .7-2.5 1.7L3.5 9.1l-.1 1v4.7a1.3 1.3 0 1 1-2.7 0v-4.7c0-.7.2-1.3.4-1.9l1.8-4.7C3.6 1.4 5.6 0 7.9 0h18.4c2.2 0 4.2 1.4 5 3.5L33 8.2c.3.6.4 1.2.4 1.9v4.7a1.3 1.3 0 1 1-2.7 0v-4.7l-.1-1-1.8-4.7c-.4-1-1.4-1.7-2.5-1.7H7.8ZM6.2 25.3c0-.7.6-1.3 1.4-1.3h5a1.3 1.3 0 1 1 0 2.7h-5c-.8 0-1.4-.6-1.4-1.4Z",
  fill: "#333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 0c.8 0 1.4.6 1.4 1.3v8a1.3 1.3 0 1 1-2.7 0v-8c0-.7.6-1.3 1.4-1.3Z",
  fill: "#333"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m16.5 29 5-8.9 2.3 1.3-5 9-2.3-1.3Zm10.8-7.6 5 9a2 2 0 0 1-1.7 3H20.5a2 2 0 0 1-1.8-3L16.5 29c-1.8 3 .4 6.9 4 6.9h10.1c3.6 0 5.8-3.9 4-7l-5-8.9-2.3 1.3Zm0 0a2 2 0 0 0-3.5 0l-2.3-1.3a4.6 4.6 0 0 1 8 0l-2.2 1.3Z",
  fill: "#EB6D6D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.6 22c.7 0 1.3.6 1.3 1.3v4a1.3 1.3 0 1 1-2.7 0v-4c0-.7.6-1.3 1.4-1.3Z",
  fill: "#EB6D6D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9 30.7a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0Z",
  fill: "#EB6D6D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.6 31a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7Zm0 1a1.3 1.3 0 1 0 0-2.7 1.3 1.3 0 0 0 0 2.7Z",
  fill: "#EB6D6D"
});

function SvgUnidentifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "35px",
    height: "36px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = React.forwardRef(SvgUnidentifiedIcon);
export default __webpack_public_path__ + "static/media/unidentified-icon.f49910c2.svg";
export { ForwardRef as ReactComponent };